import { useTranslation } from '~/common/hooks/useTranslation'
import { Button, Col, Dropdown, Form, Input, Row, Space } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import Datatable from '~/components/shared-components/Datatable'
import { useQueryState } from '~/common/hooks/useQueryState'
import TimeHelper from '~/helpers/time-helper'
import { formatAddress } from '~/helpers/common'
import configs from '~/configs'
import Profile from './form/profile'
import Achievement from './form/achievement'
import { useUser } from '~/views/app/redux/hooks/useUser'
import { converUserRankUser, handleExportCSVScreen } from '~/common/constants'
import { usePools } from '~/views/app/redux/hooks/usePools'

const ManagementUsers = () => {
  const { t } = useTranslation()
  const [formSearch] = Form.useForm()

  const USER_ROLE = [
    {
      key: '0',
      value: 'playerGameProgress.player_rank',
      label: t(`managementUsers.roleUser.ranking`),
    },
    {
      key: '1',
      value: 'last_active',
      label: t(`managementUsers.roleUser.lastActive`),
    },
    {
      key: '2',
      value: 'crt_dt',
      label: t(`managementUsers.roleUser.createdAt`),
    },
  ]
  const [role, setRole] = useState(USER_ROLE[0])

  const {
    actions,
    data: { isLoading, listUser, total },
  } = useUser()
  const { page, pageSize, keyword, setPage, setPageSize, setKeyword } =
    useQueryState()

  //Control all modal
  const [modalForm, setModalForm] = useState({
    id: null,
    isOpenModal: false,
    user: {},
    address: [],
  })
  const [modalFormAchievement, setModalFormAchievement] = useState({
    id: null,
    isOpenModal: false,
    address: null,
  })

  const columns = [
    {
      title: t('common.no'),
      dataIndex: 'key',
      key: 'key',
      render: (data) => {
        return data
      },
    },
    {
      title: t('managementUsers.form.name'),
      dataIndex: 'user_name',
      key: 'user_name',
      render: (user_name) => {
        return (
          <div className="w-full overflow-hidden text-ellipsis whitespace-nowrap max-w-[400px]">
            {user_name}
          </div>
        )
      },
    },
    {
      title: t('managementUsers.form.walletAddress'),
      dataIndex: 'address_wallet',
      key: 'address_wallet',
      render: (address_wallet) => {
        let link = `${configs.NETWORK.scan}address/${address_wallet}`
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={link}
            title={address_wallet}
            style={{ color: '#40A9FF' }}
          >
            {formatAddress(address_wallet)}
          </a>
        )
      },
    },
    {
      title: t('managementUsers.form.rank'),
      dataIndex: 'player_rank',
      key: 'player_rank',
      render: (player_rank) => {
        return (
          <div className="">
            {player_rank ? converUserRankUser(player_rank) : 'ー'}
          </div>
        )
      },
    },
    {
      title: t('managementUsers.form.ranking'),
      dataIndex: 'playerGameProgress',
      key: 'playerGameProgress',
      render: (playerGameProgress) => {
        return <div>{converUserRankUser(playerGameProgress?.player_rank)}</div>
      },
    },

    {
      title: t('managementUsers.form.bit'),
      dataIndex: 'bit_balance',
      key: 'bit_balance',
      render: (bit_balance) => {
        return <div className="">{bit_balance}</div>
      },
    },
    {
      title: t('managementUsers.form.maPoint'),
      dataIndex: 'mapoint_amount',
      key: 'mapoint_amount',
      render: (mapoint_amount) => {
        return <div className="">{mapoint_amount ? mapoint_amount : 0}</div>
      },
    },
    {
      title: t('managementUsers.form.lastActive'),
      dataIndex: 'last_active',
      key: 'last_active',
      render: (last_active) => {
        return TimeHelper(last_active)
      },
    },
    {
      title: t('managementUsers.form.createdAt'),
      dataIndex: 'crt_dt',
      key: 'crt_dt',
      render: (crt_dt) => {
        return TimeHelper(crt_dt)
      },
    },
    {
      title: t('common.action'),
      render: (_, data) => {
        return (
          <Space>
            <Button
              type="ghost"
              loading={false}
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M17.7337 15.6133C17.3127 14.6159 16.7016 13.7099 15.9346 12.9459C15.17 12.1796 14.2642 11.5687 13.2672 11.1468C13.2583 11.1423 13.2494 11.1401 13.2404 11.1356C14.6311 10.1311 15.5351 8.49498 15.5351 6.649C15.5351 3.59096 13.0574 1.11328 9.99936 1.11328C6.94132 1.11328 4.46364 3.59096 4.46364 6.649C4.46364 8.49498 5.36766 10.1311 6.75829 11.1378C6.74936 11.1423 6.74043 11.1445 6.7315 11.149C5.7315 11.5709 4.83418 12.1758 4.06409 12.9481C3.29782 13.7128 2.68687 14.6186 2.26498 15.6155C1.85052 16.5915 1.627 17.6379 1.6065 18.6981C1.60591 18.7219 1.61008 18.7456 1.61879 18.7678C1.6275 18.79 1.64056 18.8102 1.6572 18.8273C1.67384 18.8443 1.69373 18.8579 1.71569 18.8671C1.73765 18.8764 1.76124 18.8811 1.78507 18.8811H3.12436C3.22257 18.8811 3.3007 18.803 3.30293 18.707C3.34757 16.9838 4.03954 15.37 5.26275 14.1468C6.52838 12.8811 8.20918 12.1847 9.99936 12.1847C11.7895 12.1847 13.4703 12.8811 14.736 14.1468C15.9592 15.37 16.6511 16.9838 16.6958 18.707C16.698 18.8052 16.7761 18.8811 16.8744 18.8811H18.2136C18.2375 18.8811 18.2611 18.8764 18.283 18.8671C18.305 18.8579 18.3249 18.8443 18.3415 18.8273C18.3582 18.8102 18.3712 18.79 18.3799 18.7678C18.3886 18.7456 18.3928 18.7219 18.3922 18.6981C18.3699 17.6311 18.1489 16.5932 17.7337 15.6133ZM9.99936 10.4883C8.97481 10.4883 8.01052 10.0887 7.28507 9.36328C6.55963 8.63784 6.16007 7.67355 6.16007 6.649C6.16007 5.62444 6.55963 4.66016 7.28507 3.93471C8.01052 3.20926 8.97481 2.80971 9.99936 2.80971C11.0239 2.80971 11.9882 3.20926 12.7136 3.93471C13.4391 4.66016 13.8386 5.62444 13.8386 6.649C13.8386 7.67355 13.4391 8.63784 12.7136 9.36328C11.9882 10.0887 11.0239 10.4883 9.99936 10.4883Z"
                    fill="#40A9FF"
                  />
                </svg>
              }
              onClick={() =>
                onShowModalForm(data?._id, data, data.address_wallet)
              }
            />

            <Button
              type="ghost"
              loading={false}
              onClick={() => {
                onShowModalFormAchievement(data?._id, data.address_wallet)
              }}
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M18.6516 4.7386L14.3078 7.41494L10.1426 1.85913C10.1259 1.83677 10.1042 1.81862 10.0792 1.80612C10.0542 1.79362 10.0266 1.78711 9.99867 1.78711C9.97073 1.78711 9.94317 1.79362 9.91818 1.80612C9.89319 1.81862 9.87146 1.83677 9.8547 1.85913L5.69175 7.41494L1.34577 4.7386C1.21854 4.66047 1.05336 4.76538 1.07345 4.91494L2.77881 17.8748C2.80336 18.0511 2.95515 18.1873 3.13595 18.1873H16.8659C17.0444 18.1873 17.1985 18.0533 17.2208 17.8748L18.9261 4.91494C18.944 4.76538 18.781 4.66047 18.6516 4.7386ZM15.8391 16.6605H4.15827L2.95738 7.52208L6.07791 9.44396L9.99979 4.21181L13.9217 9.44396L17.0422 7.52208L15.8391 16.6605ZM9.99979 9.92833C8.61363 9.92833 7.4864 11.0556 7.4864 12.4417C7.4864 13.8279 8.61363 14.9551 9.99979 14.9551C11.386 14.9551 12.5132 13.8279 12.5132 12.4417C12.5132 11.0556 11.386 9.92833 9.99979 9.92833ZM9.99979 13.5198C9.40604 13.5198 8.9239 13.0377 8.9239 12.4417C8.9239 11.848 9.40604 11.3636 9.99979 11.3636C10.5935 11.3636 11.0757 11.8457 11.0757 12.4417C11.0757 13.0355 10.5935 13.5198 9.99979 13.5198Z"
                    fill="#FAAD14"
                  />
                </svg>
              }
            />
          </Space>
        )
      },
    },
  ]
  const params = {
    search: keyword,
    pageSize: pageSize,
    page,
    sort_by_field: role?.value,
    sort_by_dir: -1,
  }
  //Refresh data
  const refreshData = () => {
    actions.getListUser(params)
  }
  // Handle open modal (create-edit-delete)
  const onShowModalForm = (id, user, address) => {
    setModalForm({
      id,
      isOpenModal: true,
      user: user,
      address: address,
    })
  }

  const onShowModalFormAchievement = (id, address) => {
    setModalFormAchievement({
      id,
      isOpenModal: true,
      address: address,
    })
  }

  //   // Handle close modal (create-edit-delete)
  const onCloseModalForm = () => {
    setModalForm({
      id: null,
      isOpenModal: false,
      user: {},
      address: [],
    })
  }
  const onCloseModalFormAchievement = () => {
    setModalFormAchievement({
      id: null,
      isOpenModal: false,
      user: {},
    })
  }

  const handleChangeRole = (e) => {
    setRole(USER_ROLE[e.key])
  }
  const handleSearch = (values) => {
    setKeyword(values?.keyword)
  }

  useEffect(() => {
    refreshData()
  }, [page, pageSize, keyword, role])
  const {
    actions: poolsActions,
    data: { listPool },
  } = usePools()
  useEffect(() => {
    poolsActions.getListPools()
  }, [])
  const currentTimeUTC = Math.floor(Date.now() / 1000)

  const currentCycle = useMemo(
    () =>
      listPool?.find(
        (cycle) =>
          currentTimeUTC >= cycle.timeStart && currentTimeUTC <= cycle.timeEnd,
      ),
    [listPool, currentTimeUTC],
  )
  return (
    <div>
      <Row style={{ marginBottom: 16 }} gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <Button
            style={{ backgroundColor: '#1890FF' }}
            onClick={() =>
              handleExportCSVScreen('USERS', params, 'Users_Management')
            }
          >
            Export to CSV
          </Button>
        </Col>
        <Col xs={24} sm={12}>
          <div className="flex sm:justify-end w-full">
            <div className="flex gap-0 sm:gap-3 flex-wrap mb-3 sm:mb-0 w-full sm:justify-end">
              <Form
                onFinish={handleSearch}
                className="w-full sm:w-auto"
                form={formSearch}
                translate="yes"
                autoComplete="off"
                size="middle"
                validateTrigger={['onBlur', 'onChange']}
                requiredMark={false}
              >
                <Form.Item
                  className="w-full"
                  label={
                    <span className="font__M__plus font-bold">
                      {t('common.search')}
                    </span>
                  }
                  name="keyword"
                  labelAlign="left"
                >
                  <Input className="w-full" placeholder={t('common.search')} />
                </Form.Item>
              </Form>

              <div className="flex items-baseline">
                <div className="mr-2 font__Rexliafree">
                  {t('managementUsers.sortBy')}
                </div>
                <Dropdown
                  className="flex items-center cursor-pointer ml-3 sort__value"
                  menu={{
                    items: USER_ROLE,
                    selectable: true,
                    onClick: handleChangeRole,
                  }}
                  placement="bottomRight"
                  trigger={['click']}
                >
                  <Button className="flex !bg-[#0d2758] px-[10px] py-[16px] h-[44px] w-[160px]">
                    <div className="title">{role?.label}</div>
                  </Button>
                </Dropdown>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Datatable
        scroll={{ x: 1300 }}
        columns={columns}
        dataSource={listUser}
        loading={isLoading}
        showPagination
        showHeader
        metadata={{
          perPage: pageSize,
          setPerPage: setPageSize,
          page,
          setPage,
          total: total,
          keyword,
          setKeyword,
        }}
      />

      {modalForm.isOpenModal && (
        <Profile
          isShowModal={modalForm.isOpenModal}
          onClose={onCloseModalForm}
          refreshData={refreshData}
          id={modalForm.id}
          user={modalForm?.user}
          address={modalForm?.address}
          currentCycle={currentCycle}
        />
      )}
      {modalFormAchievement.isOpenModal && (
        <Achievement
          isShowModal={modalFormAchievement.isOpenModal}
          onClose={onCloseModalFormAchievement}
          refreshData={refreshData}
          id={modalFormAchievement.id}
          address={modalFormAchievement?.address}
          currentCycle={currentCycle}
        />
      )}
    </div>
  )
}

export default ManagementUsers
